module.exports = __webpack_public_path__ + "img/this_site.e59460f2.jpg";